import AppSetting from "../../config/AppSetting";

export default class TokenStorage {
  setAuthenticated = (accessToken: any, refreshToken: any, userModel: any, roleModel: any) => {
    AppSetting.localStorageValue.setAuthenticated(accessToken, refreshToken, userModel, roleModel);
  };

  setUnauthenticated = () => {
    AppSetting.localStorageValue.setUnauthenticated();
  };

  refreshToken = (accessToken: any, refreshToken: any) => {
    AppSetting.localStorageValue.refreshToken(accessToken, refreshToken);
  };

  setUserModel = (userModel: any) => {
    AppSetting.localStorageValue.user.set(userModel);
  };

  adfsAccessToken = (accessToken: any) => {
    AppSetting.localStorageValue.adfsAccessToken(accessToken);
  };
}
